/**
 * 微信服务号，管理功能界面，这个功能需登录绑定服务号
 */
import React from 'react';

import { Carousel } from 'antd-mobile';


import http from "../../../axios/wechatHttp";
import server from "../../../axios/server";

import menuData from '../../../route/menu_wxgzh';

//布局样式
import './consoleIndex.css';
//icon样式
// import '../../../style/common/icon.css';



class ConsoleIndex extends React.Component {

    state = {
        carouselList: [], //轮播图信息

        menuList: [], //菜单信息
    }

    componentDidMount() {
        //加载轮播图
        this.loadCarousel();
        //加载菜单
        this.loadMenu();
    }

    //加载轮播图
    loadCarousel = () => {
        http.post({
            url: '/findWxCarousel',
            data: {
                carouselType: 4
            },
            success: (res) => {
                if (res != null && res.length > 0) {
                    res.forEach((e) => {
                        e.image = encodeURI(server.httpServerUrl + "/common/image?imagePath=" + e.image);
                    });
                } else {
                    res = [];
                }
                this.setState({ carouselList: res });
            }
        });
    }

    //加载菜单
    loadMenu = () => {
        http.get({
            url: '/auth/findMenu',
            data: {
                type: 3
            },
            success: (res) => {
                this.setState({ menuList: res == null ? [] : res });
            }
        });
    }

    menuClick = (menuCode, e) => {
        let url = menuData[menuCode]["url"]; //要请求的服务路径地址
        // let origin = window.location.origin; //获取当前访问的web服务地址
        // let href = origin + url; //要访问的新地址
        let href = server.webServerUrl + url;
        window.location.href = href; //页面跳转
    }

    render() {
        const { carouselList, menuList } = this.state;
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <div className="layout-header">
                    <Carousel className="layout-carousel"
                        autoplay={true}
                        infinite={true}
                        autoplayInterval={5000}
                        dots={true}
                        dragging={true}
                    >
                        {carouselList.map((item, index) => {
                            return (<div key={index} className="carousel-item">
                                <img className="carousel-image" src={item.image} alt=""></img>
                            </div>);
                        })}
                    </Carousel>
                </div>
                <div className="layout-center">
                    <div className="layout-menu">
                        {menuList.map((item, index) => {
                            return <div key={item.code} className="menu-button" onClick={this.menuClick.bind(this, item.code)}>
                                <span className={"iconfont " + menuData[item.code]["icon"]}></span>
                                <div>{item.name}</div>
                            </div>
                        })}
                    </div>
                </div>
                <div className="layout-footer">
                    <div className="footer-log"></div>
                    <div>地址：福建省厦门市湖里区枋湖路8号</div>
                    <div>咨询热线：0592-5165566</div>
                </div>
            </div>
        )
    }
}

export default ConsoleIndex;


